import { render, staticRenderFns } from "./ViberBusinessWizard.vue?vue&type=template&id=60599a21&"
import script from "./ViberBusinessWizard.vue?vue&type=script&lang=js&"
export * from "./ViberBusinessWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports